<!--
  layou组件
-->
<template>
  <div class="layout_mian" v-if="!$route.meta.noLayout">
    <div class="layout_left">
      <leftMenu />
    </div>
    <div class="layout_right">
      <navBar></navBar>
      <tags-view />
      <appMain />
    </div>
  </div>
  <div v-else>
    <appMain />
  </div>
</template>

<script>
export default {
  name: "layout",
  components: {
    leftMenu: () => import("./leftMenu/index.vue"),
    navBar: () => import("./navBar/index.vue"),
    appMain: () => import("./appMain/index.vue"),
    tagsView: () => import("./TagsView/index.vue"),
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/layout/index.vue